import { useQuery } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import { ClaimDetailResponse } from './types'
import config from '@/config'

const fetchClaimDetail = async (claimId: string) => {
  const response = await httpClientPrivate.get<ClaimDetailResponse>(
    `${config.restUrl}/v1/backoffice/health-claim/${claimId}`,
  )

  return response.data
}

const useGetClaimDetail = (claimId?: string) => {
  const query = useQuery<ClaimDetailResponse>({
    queryKey: ['useGetClaimDetail', claimId],
    queryFn: async () => fetchClaimDetail(claimId!),
    enabled: !!claimId,
  })

  return { ...query }
}

export { useGetClaimDetail }
